export const STAT_CATEGORY_ACCOUNT_SETTINGS = 'Account Settings';
export const STAT_GROUP_SETTING_CHANGE = 'Setting Change';
export const STAT_GROUP_ID_CODE = 'ID Code';
export const STAT_GROUP_SIM = 'SIM Management';

export const STAT_CATEGORY_ORDERS = 'Orders';
export const STAT_GROUP_GIGAMARKET = 'Gigamarket Order';
export const STAT_GROUP_DATA_BUTTON_ORDER = 'DataButton Order';
export const STAT_GROUP_SHS_ORDER = 'SHS Order';
export const STAT_GROUP_NZ_ORDER = 'NZ Order';
export const STAT_GROUP_STARTER_PACK_ORDER = 'Starter Pack Order';

export const STAT_CATEGORY_OST_ORDERS = 'OST Orders';
export const STAT_GROUP_OST_ACTIVATION = 'OST Activation';
export const STAT_GROUP_OST_DEACTIVATION = 'OST Deactivation';
export const STAT_GROUP_OST_UPDATE = 'OST Update';
export const STAT_GROUP_OST_COMPLEX_ORDER = 'OST Complex Order';

export const STAT_CATEGORY_PAYMENTS = 'Payments';
export const STAT_GROUP_INVOICE_PAYMENT = 'Invoice Payment';
export const STAT_GROUP_CREATE_AUTO_CARD_PAYMENT = 'Create Auto Card Payment';
export const STAT_GROUP_CANCEL_AUTO_CARD_PAYMENT = 'Cancel Auto Card Payment';

export const STAT_CATEGORY_OTHER = 'Other';
export const STAT_GROUP_SSO = 'SSO';
export const STAT_GROUP_LOYALTY = 'Loyalty';
export const STAT_GROUP_LOVE = 'Love';
export const STAT_GROUP_TROUBLE_TICKETS = 'Trouble Tickets';
export const STAT_GROUP_CONSUMPTION = 'Consumption';
export const STAT_GROUP_OST_OTHER = 'OST Other';
export const STAT_GROUP_PREPAID_AUTOPAY = 'Prepaid Autopay';
export const STAT_GROUP_POSTPAID_TO_PREPAID = 'Postpaid to Prepaid';
